export const ValidateCost = (value) => {
  if (!value.match(/^(?:\d{0,5}\.{0,1})\d{0,5}$/)) {
    return false;
  }

  const valueParse = value.split(".");
  if (
    (valueParse.length <= 2 && valueParse[0].length > 5) ||
    (valueParse.length === 2 && valueParse[1].length > 5)
  ) {
    return false;
  } else {
    return true;
  }
};

export const HandleCostPaste = (event) => {
  const value = event.clipboardData.getData("text");
  if (!ValidateCost(value)) {
    event.preventDefault();
  }
};

export const HandleCostKey = (event) => {
    const value = event.target.value;
    if (!ValidateCost(value)) {
      event.preventDefault();
    }
  if (
    value.endsWith(".") &&
    (event.key === "Backspace" || event.key === "Delete")
  ) {
    event.target.value = value.slice(0, -1);
  } else if (!value.includes(".") && value.length === 5) {
    event.target.value += ".";
  }
};
